import PropTypes from 'prop-types';
import css from './ListingPage.module.css';
import { FormattedMessage } from 'react-intl';

import {
  formatTime,
  formatDayRangeLabel,
  groupOpeningHours,
  isSameTimeAllWeek,
} from '../../util/openingHoursHelpers';

const OpeningHours = ({ availability }) => {
  const entries = availability?.entries || [];
  const allWeekSameTime = isSameTimeAllWeek(entries);

  const renderHours = () => {
    if (!entries.length) return null;

    // If ALL 7 days have same time => show existing "daysText" label (Mon - Sun)
    if (allWeekSameTime) {
      return (
        <div className={`${css.hoursRow} ${css.hoursRowAllWeek}`}>
          <span className={`${css.days} ${css.daysRange}`}>
            <FormattedMessage id="OpeningHours.daysText" />
          </span>
          <span className={css.time}>
            {formatTime(entries[0].startTime)} - {formatTime(entries[0].endTime)}
          </span>
        </div>
      );
    }

    // Otherwise group consecutive days with the same time (e.g., Mon - Fri)
    const grouped = groupOpeningHours(entries);

    return grouped.map((g, index) => (
      <div className={`${css.hoursRow} ${css.hoursRowDaily}`} key={index}>
        <span className={`${css.days} ${css.daysShort}`}>
          {formatDayRangeLabel(g.startDay, g.endDay)}
        </span>
        <span className={css.time}>
          {formatTime(g.startTime)} - {formatTime(g.endTime)}
        </span>
      </div>
    ));
  };

  return (
    <div className={css.container}>
      <h3 className={css.sectionHeading}>
        <FormattedMessage id="OpeningHours.openingHours" />
      </h3>
      {renderHours()}
    </div>
  );
};

OpeningHours.propTypes = {
  availability: PropTypes.shape({
    entries: PropTypes.arrayOf(
      PropTypes.shape({
        dayOfWeek: PropTypes.string.isRequired,
        startTime: PropTypes.string.isRequired,
        endTime: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

export default OpeningHours;
